/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { Button, Divider, Badge, Modal, Image } from "antd";
import classNames from "classnames";
/* Package JSON Import will be here */

/* Project Import will be here */
import store from "assets/img/store.png";
import arrowDown from "assets/img/arrow-down.png";
import logo from "assets/img/logo-icon.png";
import { getNotificationCount } from "reducers/notifications";
import SearchProducts from "./SearchProducts";
import MobileCategoryMenu from "./MobileCategoryMenu";
import { appRoutesConst, ManageWholesalerLink, navigateToProductList, navigateToCart } from "app/navigation";
import { getCartDetails, cartUpload } from "reducers/cart";
import DrawerMenu from "components/menu/DrawerMenu";
import { GAMenuDrawer } from "hooks/googleAnalyticsHooks";
import ApprovedWholesalerListItem from "components/wholesalers/ApprovedWholesalerListItem";
import TooltipComp from "components/reusable/TooltipComp";
import pendingTaskImg from "assets/img/pending-task.png";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { confirm } = Modal;
/* Const,Let & Var will be here */

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWholesaler: false,
      mobileMenu: false,
      isShowDrawerMenu: false,
      isAddToHomeScreenAvailable: true
    };

    /* Get the notification count to be displayed in the bell icon */
    this.props.actions.getNotificationCount();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  drawerMenuClose = () => {
    this.setState({
      isShowDrawerMenu: false
    });
  }

  openDrawerMenu = () => {
    let path = this.props.router.location.pathname;
    /* Do not open the drawer menu when the user is in cart page */
    if (path !== appRoutesConst.orderSummary) {
      this.setState({ isShowDrawerMenu: true });

      /* GA - Track menu drawer initiation  */
      if (window.isEnableGA)
        GAMenuDrawer();
    }
  }

  toggleWholesaler = () => {
    this.setState({
      showWholesaler: !this.state.showWholesaler
    });
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      if (this.state.showWholesaler)
        this.setState({ showWholesaler: false });
    }
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  toggleMobileMenu = () => {
    this.setState({ mobileMenu: !this.state.mobileMenu });
  };

  handleBackNavigation = () => {
    const { cart, actions, translate } = this.props;

    let checkProductChange = false;
    let products = this.props.orders.data;
    Object.keys(products).forEach(id => {
      if (products[id].isChanged) checkProductChange = true;
    });

    if (checkProductChange || cart.uploadLoading) {
      confirm({
        icon: null,
        title: <div className="text-center">
          <img src={pendingTaskImg} alt="pending Task" className="pending-task-icon" />
          <div>{translate("common.alerts.confirmation.cartBackConfirmation")}</div>
        </div>,
        centered: true,
        okText: translate("common.buttons.yes"),
        cancelText: translate("common.buttons.no"),
        okButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
        cancelButtonProps: { size: "large", shape: "circle", style: { width: "100px" } },
        onOk: async () => {
          await actions.getCartDetails();
          actions.navigateToProductList();
        }
      });
    }
    else {
      actions.navigateToProductList();
    }
  };
  
  handleGoBack = () => {
    let currentPath = this.props.router.location.pathname;

    if (currentPath === appRoutesConst.orderSummary)
      this.handleBackNavigation();
    else if (currentPath === appRoutesConst.checkout)
      this.props.actions.navigateToCart();
    else
      this.props.history.goBack();
  };

  renderWholesalerMenu = () => {
    const { selectedWholesaler, wholesalers, translate } = this.props;

    return (
      selectedWholesaler && wholesalers.data.length > 0 && (
        <li className="nav-item mr-24 navlink--border-right">
          <div
            className="nav-link d-flex align-items-center cursor-pointer color-white"
            onClick={(e) => {
              e.preventDefault();
              this.toggleWholesaler();
            }}
          >
            <img src={store} alt="store" className="mr-5 mt-minus-3" />
            <span className="nav-agency-name"> {selectedWholesaler.dName}</span>
            <img alt="" className="mt-minus-3" src={arrowDown} />
          </div>

          <div
            style={{ display: this.state.showWholesaler ? "block" : "none" }}
            className="dropdown-menu dropdown-menu-right account--dropdown whole-seller__drop p-3"
          >
            <ApprovedWholesalerListItem
              translate={translate}
              wholesaler={selectedWholesaler}
              isFromHeader={true}
            />

            {this.props.appSettings.isEnableManageDistributors &&
              <React.Fragment>
                <Divider />

                <div className="text-center">
                  <ManageWholesalerLink>
                    <Button type="link" onClick={this.toggleWholesaler}>
                      {this.props.translate("common.links.manageDistributors")}
                    </Button>
                  </ManageWholesalerLink>
                </div>
              </React.Fragment>
            }
          </div>
        </li>
      )
    );
  };

  render() {
    const { cart, notifications, translate, appSettings, localStore, router } = this.props;
    let path = router.location.pathname;
    const backDisabledPaths = [appRoutesConst.home];
    const shouldShowBackIcon = backDisabledPaths.includes(path);

    /* Check for token availability */
    if (!localStore.token)
      return "";

    return (
      <React.Fragment>
        <header className="header header-shadow">
          <nav className="navbar navbar-expand-lg nav-md">
            {/* Hamburger menu */}
            {(path !== appRoutesConst.orderSummary) &&
              <div className="nav-link nav-link-drawer-menu-padding mt-1">
                <i onClick={this.openDrawerMenu} className="fa fa-bars fa-lg fav-product-header-icon cursor-pointer" aria-hidden="true"></i>
              </div>
            }

            {/* Client logo */}
            <div className="col-xs-6 col-sm-6 col-md-6">
              {/* Back button */}
              {!shouldShowBackIcon &&
                <TooltipComp title={translate("common.buttons.back")}>
                  <i className="fa fa-chevron-left mr-4 font-15 cursor-pointer color-white" aria-hidden="true" onClick={this.handleGoBack}></i>
                </TooltipComp>
              }

              {(path === appRoutesConst.orderSummary) ?
                <div className="navbar-brand">
                  <Image
                    className="client-image-height"
                    src={window.logoUrl + 'headerlogo.png'}
                    alt={translate("common.imageAlt.headerLogo")}
                    fallback={logo}
                    preview={false}
                  />
                </div>
                :
                <Link to={appSettings.isEnableHomePage ? appRoutesConst.home : appRoutesConst.productList} className="navbar-brand">
                  <Image className="client-image-height"
                    src={window.logoUrl + 'headerlogo.png'}
                    alt={translate("common.imageAlt.headerLogo")}
                    fallback={logo}
                    preview={false}
                  />
                </Link>
              }
            </div>

            {/* Menu icons */}
            {(path !== appRoutesConst.orderSummary) &&
              <div className="col-xs-6 col-sm-6 col-md-6 pl-0">
                  <ul
                    ref={this.setWrapperRef}
                    className="navbar-nav flex-row justify-content-end align-items-center"
                  >
                  {appSettings.isEnableManageDistributors && this.renderWholesalerMenu()}

                  {appSettings.isFavProductEnable &&
                      <li className="nav-item mr-24">
                        <Link to={appRoutesConst.favProducts} className="nav-link">
                          <i className="fa fa-heart fa-lg" aria-hidden="true"></i>
                        </Link>
                      </li>
                    }

                  {appSettings.isShowNotifications &&
                      <li className="nav-item mr-24 cart__link--content">
                        <Link to={appRoutesConst.notification} className="nav-link">
                        <Badge count={notifications.count} overflowCount={99} offset={[5, -2]} className="custom-badge-header">
                          <i className={classNames('fa fa-bell fa-lg', { 'animate-ring': notifications.count > 0 })} aria-hidden="true"></i>
                        </Badge>
                        </Link>
                      </li>
                    }

                    <li className="nav-item mr-24 cart__link--content cart-icon-with-count">
                    <Badge count={cart.ids.length + cart.freeProducts.length} overflowCount={99} offset={[5, -1]} className="custom-badge-header">
                      <Link to={appRoutesConst.orderSummary} className="nav-link">
                        <i className="fa fa-cart-arrow-down font-22  fa-lg" aria-hidden="true"></i>
                      </Link>
                    </Badge>
                    </li>

                    <li className="nav-item mr-24">
                      <SearchProducts />
                    </li>
                  </ul>
                </div>
            }
          </nav>

          {/* Mobile header */}
          <MobileCategoryMenu handleGoBack={this.handleGoBack} openDrawerMenu={this.openDrawerMenu} translate={translate} />
        </header>

        {/* Menu drawer for both web and mobile */}
        <DrawerMenu isShowDrawerMenu={this.state.isShowDrawerMenu} drawerMenuClose={this.drawerMenuClose} />
      </React.Fragment >
    );
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications,
  cart: state.cart,
  orders: state.orders,
  wholesalers: state.wholesalers,
  categoryMenu: state.categoryMenu,
  selectedWholesaler: state.localStore.selectedWholesaler,
  translate: getTranslate(state.locale),
  appSettings: state.appSettings,
  router: state.router,
  localStore: state.localStore
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getCartDetails,
      getNotificationCount,
      navigateToProductList,
      navigateToCart,
      cartUpload
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));